import AppObj from "./appConfigObj";

/*
interface TaskObj {
    zindex: number;
    app: AppObj
    taskTitle: string;
    taskID: string;
    state:number //0 = killing 1=opening and unfocus 2=opeing and focused 3=opening and minimized;
    forceSummon: boolean;
    taskInitParms: TaskInitParams[];
    screenShortFun?: Function;
    taskWindowRef? :null | HTMLElement;
}
*/

class TaskObj {
    zindex: number = 0;
    app: AppObj = {} as AppObj;
    taskTitle: string = '';
    taskID: string = '';
    state: "killing" | "unfocus" | "focus" | "minimized" = "killing";
    spotlighted: boolean = false;
    /** When false, window chrome hides close and kill is blocked. */
    closable: boolean = true;
    taskInitParms: TaskInitParams[] = [];
    taskWindowRef?: null | HTMLElement;
    setTaskWindowsRef = (refItem: HTMLDivElement) => {
        this.taskWindowRef = refItem;
    }
}

export interface TaskInitParams {
    command: string;
    value: string;
}

export default TaskObj;